import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useDefaultSearch } from './useDefaultSearch';
import Dropdown from '../../../../lib/inputs/Dropdown';
import { handleChange } from '../constants/ticketlist.utils';
import GIButton from '../../../../components/common/button/GIButton';
import { IDefaultSearchProps } from '../constants/ticketlist.interface';
import { FlexRow, FlexItem, StyledForm, StyledControlButton } from '../constants/ticketlist.styled';
import { INPUT_TYPES } from '../../../../components/common/form/constants/fieldTypes';
import { ticketAssignmentOptions, ticketStatusOptions } from '../constants/ticketlist.constants';

export const DefaultSearch: React.FC<IDefaultSearchProps> = props => {
    const { pageSortInfo, workgroupOptions } = props;

    const { setValue, handleSubmit, watch, fetchFilteredTickets: onSubmit } = useDefaultSearch({ pageSortInfo });

    const values = watch();

    return (
        <StyledForm onSubmit={handleSubmit(onSubmit)}>
            <FlexRow>
                <FlexItem>
                    <Dropdown
                        label={{
                            text: <FormattedMessage id="ticketList.label.workgroup" />,
                            labelClass: ['dropdown-label'],
                        }}
                        inputData={{
                            id: 'workgroup',
                            inputClass: ['dropdown-input'],
                            name: 'documentType',
                            type: INPUT_TYPES.DROPDOWN,
                            value: values.workgroup,
                            options: workgroupOptions,
                        }}
                        inputActions={{
                            handleFieldChange: e => handleChange('workgroup', e, setValue),
                        }}
                    />
                </FlexItem>
                <FlexItem>
                    <Dropdown
                        label={{
                            text: <FormattedMessage id="ticketList.label.ticketStatus" />,
                            labelClass: ['dropdown-label'],
                        }}
                        inputData={{
                            id: 'ticketStatus',
                            inputClass: ['dropdown-input'],
                            name: 'documentType',
                            options: ticketStatusOptions,
                            type: INPUT_TYPES.DROPDOWN,
                            value: values.ticketStatus,
                        }}
                        inputActions={{
                            handleFieldChange: e => handleChange('ticketStatus', e, setValue),
                        }}
                    />
                </FlexItem>
                <FlexItem>
                    <Dropdown
                        label={{
                            text: <FormattedMessage id="ticketList.label.ticketAssignment" />,
                            labelClass: ['dropdown-label'],
                        }}
                        inputData={{
                            id: 'ticketAssignment',
                            inputClass: ['dropdown-input'],
                            name: 'documentType',
                            options: ticketAssignmentOptions,
                            type: INPUT_TYPES.DROPDOWN,
                            value: values.ticketAssignment,
                        }}
                        inputActions={{
                            handleFieldChange: e => handleChange('ticketAssignment', e, setValue),
                        }}
                    />
                </FlexItem>
                <StyledControlButton>
                    <GIButton
                        id="defaultSearchButton"
                        labelId="ticketList.btn.searchMyTicket"
                        type="submit"
                        isDisabled={false}
                    />
                </StyledControlButton>
            </FlexRow>
        </StyledForm>
    );
};
